import { render, staticRenderFns } from "./studentDetailLIst.vue?vue&type=template&id=5b5e4afa&scoped=true"
import script from "./studentDetailLIst.vue?vue&type=script&lang=js"
export * from "./studentDetailLIst.vue?vue&type=script&lang=js"
import style0 from "./studentDetailLIst.vue?vue&type=style&index=0&id=5b5e4afa&prod&lang=less"
import style1 from "./studentDetailLIst.vue?vue&type=style&index=1&id=5b5e4afa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5e4afa",
  null
  
)

export default component.exports